<template>
  <div class="page">
    <nav-bar />
    <div class="page-wrapper--new">
      <div class="select-component">
        <div class="select-component__main">
          <div class="page-nav" v-if="isWizard">
            <h2 class="page-nav__title">Шаг 3</h2>
            <p class="page-nav__current">Компоненты</p>
          </div>
          <h1 class="editor--title" v-if="isWizard">
            Выбор компонентов
          </h1>
          <h1 class="editor--title" v-else>Настройка страницы</h1>
          <p class="editor--subtitle" v-if="isWizard">
            Компоненты — это элементы, из которых состоит ваша страница.
            «Контакты» обязателен к заполнению, к счастью мы с вами уже его
            заполнили. А другие компоненты можно включить и настроить по
            желанию. После настройки компонентов используйте «Предпросмотр»,
            чтобы увидеть, как выглядит ваша страница.
          </p>
          <div class="select-component__list">
            <div class="select-component__item" v-if="!isWizard">
              <EditComponent
                title="Шаблон"
                type="Template"
                link="/templates"
                :value="true"
              />
            </div>

            <div
              v-for="(item, index) in items"
              :key="index"
              class="select-component__item"
              v-if="!($store.state.isKZ && item.type === 'Events')"
            >
              <EditComponent
                :title="item.name"
                :type="item.type"
                :link="item.link"
                @input="e => checkAndSync(e, item.type)"
                v-model="item.enabled"
              />
            </div>
          </div>
          <div class="editor__buttons">
            <button
              class="editor__back"
              @click="
                () => {
                  $router.go(-1);
                  this.GAEvent('profile-edit_back');
                }
              "
            >
              <svg-icon type="back" />
              Назад
            </button>
            <button class="editor__preview" @click="openPreview">
              <svg-icon class="editor__icon" type="eye-black" />
              Предпросмотр
            </button>
            <button v-if="isWizard" class="editor__save" @click="enablePage">
              Опубликовать
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EditComponent from "../components/EditComponent";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "SelectComponent",
  components: { EditComponent },
  props: ["isWizard"],
  data() {
    const thisUserTypes = this.$store.state.user.user_type.map(i => i.code);

    let items = [
      {
        name: "Контакты",
        type: "Profile",
        tooltip: "Контакты",
        visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
        enabled: false,
        link: "/edit/profile"
      },
      // {
      //   name: "Фон страницы",
      //   type: "Background",
      //   tooltip: "Фон страницы",
      //   visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
      //   enabled: false,
      //   link: "/edit/backgrounds"
      // },
      {
        name: "Продукты",
        type: "Products",
        tooltip: "Продукты",
        visibleFor: ["abo", "allstar", "abo_meeting"],
        enabled: false,
        link: "/edit/products"
      },
      {
        name: "Рекомендуемые продукты",
        type: "Products",
        tooltip: "Продукты",
        visibleFor: ["vip"],
        enabled: false,
        link: "/edit/products"
      },
      {
        name: "Личные достижения",
        type: "Achievements",
        tooltip: "Личные достижения",
        visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
        enabled: false,
        link: "/edit/achievements"
      },
      {
        name: "Мероприятия Amway",
        type: "Events",
        tooltip: "Мероприятия Amway",
        visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
        enabled: false,
        link: "/edit/events"
      },
      /*{
        name: "Мои мероприятия",
        type: "MyEvents",
        tooltip: "Мои мероприятия",
        visibleFor: ["abo_meeting"],
        enabled: false,
        link: "/"
      },*/
      {
        name: "Мои сертификаты",
        type: "Certificates",
        tooltip: "Мои сертификаты",
        visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
        enabled: false,
        link: "/edit/certificates"
      },
      {
        name: "Социальные сети",
        type: "SocialLinks",
        tooltip: "Социальные сети",
        visibleFor: ["abo", "allstar", "abo_meeting", "vip"],
        enabled: false,
        link: "/edit/social"
      }
    ];
    items = items.filter(c => {
      let enabled = false;
      c.visibleFor.forEach(v => {
        if (!enabled) {
          enabled = enabled || thisUserTypes.includes(v);
        }
      });
      return enabled;
    });
    return {
      items
    };
  },

  computed: {
    ...mapState(["user", "page"]),
    ...mapGetters(["isEnabled", "idFromType", "getComponentByName"]),
    enabledStatus() {
      const result = {};
      this.items.forEach(c => {
        result[c.type] = this.isEnabled(c.type);
      });
      return result;
    }
  },

  mounted() {
    this.fillModalFromState();
  },

  methods: {
    ...mapActions(["syncComponent", "setPageEnabled", "wizardStepChange"]),
    enablePage() {
      this.GAEvent(
        "step_3-succsess-page_publication",
        "chosen_components",
        this.$store.state.page.components
          .filter(c => c.enabled)
          .map(c => c.type)
          .join(",")
      );
      this.setPageEnabled(true);
      this.wizardStepChange(4);
      this.$router.push("/wizard/4");
    },
    openPreview() {
      const win = window.open(
        `${
          /^kz/.test(window.location.host)
            ? process.env.VUE_APP_PAGE_PREVIEW_KZ
            : process.env.VUE_APP_PAGE_PREVIEW
        }/${this.user.abo_number}`,
        "_blank"
      );
      win.focus();
    },
    fillModalFromState() {
      let componentTypes = [];
      this.items.forEach(item => {
        componentTypes.push(item.type);
      });
      componentTypes.forEach((comp, index) => {
        this.items[index].enabled = this.getComponentByName(comp).enabled;
      });
    },
    checkAndSync(enabled, type) {
      if (enabled) {
        let needEdit = false;
        const component = this.getComponentByName(type);
        console.log(component);
        switch (type) {
          case "Products":
          case "Achievements":
          case "Events":
            if (
              component.content.length === 0 ||
              component.content.items.filter(c => c.enabled).length === 0
            ) {
              needEdit = true;
            }
            break;
          case "Certificates":
          case "SocialLinks":
            if (
              component.content.length === 0 ||
              component.content.items.length === 0
            ) {
              needEdit = true;
            }
            break;
        }
        if (needEdit) {
          this.$router.push(this.items.find(i => i.type === type).link);
        }
      }
      this.syncComponent({
        enabled: enabled,
        id: this.idFromType(type)
      });
      this.GAEvent(
        "profile-edit_components",
        "chosen_components",
        this.$store.state.page.components
          .filter(c => c.enabled)
          .map(c => c.type)
          .join(",")
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars.scss";

.page {
  background: #3479cc;
  @media #{$tablet} {
    padding-bottom: 0;
  }
}

.select-component {
  width: 100%;
  max-width: 1280px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  @media #{$tablet} {
    min-height: calc(100vh - 75px);
    border-radius: 0;
    justify-content: space-between;
  }
  @media #{$mobile} {
    background: #ffffff;
  }

  * {
    font-family: "Inter", sans-serif;
  }

  &__title {
    font-size: 48px;
    font-weight: bold;
    text-align: left;
    margin: 0 0 60px;
    padding: 0;
    @media #{$mobile} {
      font-size: 34px;
      margin: 0 0 30px;
      padding: 0 15px;
    }
  }

  &__description {
    max-width: 615px;
    margin-bottom: 45px;

    font-size: 16px;
    line-height: 22px;

    color: #212121;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  &__item {
    box-sizing: border-box;
    flex-basis: 360px;
    margin-bottom: 30px;
    margin-right: 30px;
    &:nth-child(3n) {
      margin-right: 0;
    }
    @media (max-width: 1270px) {
      flex-basis: calc(50% - 23px);
      margin-right: 23px !important;
      &:nth-child(2n) {
        margin-right: 0 !important;
      }
    }

    @media #{$mobile} {
      flex-basis: 100%;
      margin-right: 0 !important;
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 30px;
      }
    }
  }

  &__buttons {
    background: #ffffff;
    padding-top: 95px;
    display: flex;
    justify-content: space-between;
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }

  &__back {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    background: transparent;
    border: none;
    position: relative;
    cursor: pointer;
    @media #{$mobile} {
      margin-bottom: 30px;
    }

    span {
      margin-right: 10px;
    }
  }

  &__preview {
    display: flex;
    align-items: center;

    font-size: 18px;
    line-height: 17px;
    text-transform: uppercase;

    background: transparent;
    border: none;

    cursor: pointer;
    font-weight: bold;
  }

  &__icon {
    margin-right: 10px;
  }

  &__save {
    border-radius: 5px;
    border: none;
    background: #3a5eec;
    color: #ffffff;
    cursor: pointer;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 600;
    padding: 15px 40px;
    @media #{$mobile} {
      margin-bottom: 30px;
    }
  }
}
</style>
